import { expandNavigationPanelRows } from '../slices/panelDataSlice';
import { ThunkActionReturn } from './thunkActions';

export const expandNavigationPanelRowsIfNeeded =
  (rows: string[]): ThunkActionReturn<boolean> =>
  (dispatch, getState) => {
    const expandedRows = getState().panelData.expandedNavPanelRows;
    const rowsNeedingExpansion = rows.filter((row) => !expandedRows.includes(row));

    const rowsNeedExpanding = rowsNeedingExpansion.length > 0;
    if (rowsNeedExpanding) {
      dispatch(expandNavigationPanelRows(rowsNeedingExpansion));
    }

    return rowsNeedExpanding;
  };
